export default __webpack_public_path__ + "static/makula-zurich-abde52a6e6cc6da33cce68f7b9ae2cc2.jpeg";